<template>
    <div class="instagram-wrapper">
        <iframe
            v-if="!iframeError"
            :src="reel_id"
            class="instagram-media instagram-media-rendered"
            id="instagram-embed-0"
            allowtransparency="true"
            allowfullscreen="true"
            frameborder="0"
            height="943"
            scrolling="no"
        ></iframe>
        <div v-if="iframeError" class="instagram-fallback">
            <p>No se pudo cargar el contenido de Instagram.</p>
            <a :href="instagramUrl" target="_blank" rel="noopener noreferrer" class="instagram-link">
                Ver en Instagram
            </a>
        </div>
    </div>
</template>
<script>
export default {
    props: ['reel_id'],
    data() {
        return {
            iframeError: false,
            loadTimeout: null
        }
    },
    computed: {
        instagramUrl() {
            // Convierte la URL de embed a la URL pública del reel
            return this.reel_id ? this.reel_id.replace('/embed/captioned/', '') : 'https://www.instagram.com/merengonbavaro';
        }
    },
    mounted() {
        // Fallback por timeout: si en 8 segundos no llega un postMessage de Instagram,
        // asumimos que el embed falló (redirigió al login o error de red).
        this.loadTimeout = setTimeout(() => {
            this.iframeError = true;
        }, 8000);

        // Instagram envía postMessages desde el iframe cuando el embed carga correctamente.
        // Esto es más fiable que el evento @load, que se dispara también cuando
        // Instagram redirige al login o la carga termina en chrome-error://
        window.addEventListener('message', this.onInstagramMessage);
    },
    beforeDestroy() {
        clearTimeout(this.loadTimeout);
        window.removeEventListener('message', this.onInstagramMessage);
    },
    methods: {
        onInstagramMessage(event) {
            if (event.origin === 'https://www.instagram.com') {
                // El embed cargó correctamente: cancelamos el timeout de fallback
                clearTimeout(this.loadTimeout);
            }
        }
    }
}
</script>
<style scoped>
.instagram-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.instagram-fallback {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 20px;
    border: 1px solid #dbdbdb;
    border-radius: 8px;
    background: #fafafa;
    min-width: 280px;
}
.instagram-fallback p {
    color: #555;
    margin-bottom: 16px;
}
.instagram-link {
    display: inline-block;
    padding: 10px 24px;
    background: linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888);
    color: white;
    border-radius: 6px;
    text-decoration: none;
    font-weight: bold;
}
.instagram-link:hover {
    opacity: 0.9;
    color: white;
    text-decoration: none;
}
</style>